import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { ApplicantCardView } from './ApplicantCardView';

export function ApplicantCard({ applicationID }: { applicationID: string }) {
  const { data: applicationData } = useLoanApplication(applicationID);

  if (!applicationData) return null;

  return (
    <ApplicantCardView applicationID={applicationID} key={applicationID} />
  );
}
